
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/web-analytics",
      function () {
        return require("private-next-pages/services/web-analytics.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/web-analytics"])
      });
    }
  